<div class="flex flex-col gap-5">
  <error-component></error-component>
</div>
